export default {
    getStats: {
        method: 'GET',
        path: '/status-json.xsl',
        auth: false,
    },
    updateSource: {
        method: 'GET',
        path: '/admin/metadata',
        auth: true,
        xml: true,
    },
};
